package com.havn.app.features.auth.domain

import com.havn.app.core.media.HavnPickedPhoto
import kotlinx.coroutines.flow.StateFlow

interface AuthRepository {
    val authState: StateFlow<AuthState>

    suspend fun awaitSessionRestore()
    suspend fun signInWithGoogle(): Result<Unit>
    suspend fun signInWithApple(): Result<Unit>
    fun isAppReviewEmail(email: String): Boolean
    suspend fun agentExistsForEmail(email: String): Result<Boolean>
    suspend fun sendEmailOtp(email: String): Result<Unit>
    suspend fun signInWithAppReviewCode(email: String, code: String): Result<Unit>
    suspend fun verifyEmailOtp(email: String, code: String): Result<Unit>
    suspend fun ensureAgentProfile(user: AuthUser): Result<Unit>
    suspend fun agentProfile(userId: String): Result<AgentProfile>
    suspend fun updateAgentProfile(userId: String, firstName: String, lastName: String): Result<AgentProfile>
    suspend fun updateAgentPhoto(userId: String, photo: HavnPickedPhoto): Result<AgentProfile>
    suspend fun logout(): Result<Unit>
}

sealed interface AuthState {
    data object Loading : AuthState
    data object LoggedOut : AuthState
    data class LoggedIn(val user: AuthUser) : AuthState
    data class Error(val message: String) : AuthState
}

data class AuthUser(
    val id: String,
    val email: String?
)

data class AgentProfile(
    val id: String,
    val firstName: String,
    val lastName: String,
    val fullName: String,
    val email: String?,
    val avatarDataUrl: String? = null
)
